import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useState } from "react";
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogActions from "@mui/material/DialogActions";
import { ToastContainer, toast } from "react-toastify";
import axios from '../../../../utils/fvAxios';

export default function SetupInvitationRemindersEditandAdd({
  ID,
  CLOSE,
  CLIENTID,
  DATA,
  INFO,
  SETUPID
}) {
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };
  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const [FNotification, setFNotification] = useState(
    ID == 1 ? "" : DATA?.firstNotification
  );
  const [SNotification, setSNotification] = useState(
    ID == 1 ? "" : DATA?.secondNotification
  );
  const [TNotification, setTNotification] = useState(
    ID == 1 ? "" : DATA?.thirdNotification
  );

  const [FError, setFError] = useState("");
  const [SError, setSError] = useState("");
  const [SError1, setSError1] = useState("");
  const [TError, setTError] = useState("");
  const [TError1, setTError1] = useState("");
  const [TError2, setTError2] = useState("");
  const [Dis, setDis] = React.useState(false);

  const ChangeNotification = (ans) => {
    setSNotification("");
    //setSError("");
    if (ans?.length <= 2) {
      if (ans < 30 && ans >= 1) {
        setFNotification(ans);
        setFError("");
        setSError("");
        setSError1("");
        setTError1("")
        setTError2("")
      } else if (ans == "" || ans == 0) {
        setFNotification("");
        setSNotification("");
        setTNotification("");
        setFError("");
        setSError("");
        setTError("");
        setSError1("");
        setTError1("");
        setTError2("")
      } else {
        setFNotification("");
        setFError("Number of days should be less than 30 days");
      }
    }
  };
  const ChangeNotification2 = (ans) => {
    setTNotification("");
    //setTError("");
    if (Number(FNotification) != "") {
      if (ans?.length <= 2) {
        if (ans < 30 && ans >= 1) {
          if (Number(FNotification) < Number(ans)) {
            setSNotification(ans);
            setSError("");
            setTError("");
            setTError1("")
            setTError2("")
            setSError1("")
          } else if (ans == "" || ans == 0) {
            setSNotification(ans);
            setTNotification("");
            setSError("");
            setTError("");
            setTError1("")
            setTError2("")
            setSError1("")
          } else {
            setSNotification(ans);
            setSError("Second Notification should be greater than first notification");
            setSError1("")
          }
        } else if (ans == "") {
          setSNotification("");
          setTNotification("");
          setSError("");
          setTError("");
          setTError1("")
          setTError2("")
          setSError1("")
        } else {
          setSNotification("");
          setSError("");
          setSError1("Number of days should be less than 30 days")
        }
      }
    } else {
      setSNotification("");
      setSError("");
      setSError1("Please Enter First notification")
    }
  };
  const ChangeNotification3 = (ans) => {
    if (Number(SNotification) != "") {
      if (ans?.length <= 2) {
        if (ans < 30 && ans >= 1) {
          if (Number(SNotification) < Number(ans)) {
            setTNotification(ans);
            setTError("");
            setTError1("")
            setTError2("")
          
          } else if (ans == "" || ans == 0) {
            setTNotification(ans);
            setTError("");
            setTError1("");
            setTError2("")
          } else {
            setTNotification(ans);
            setTError("Third Notification should be greater than second notification");
            setTError1("")
            setTError2("")
          }
        } else if (ans == "") {
          setTNotification("");
          setTError("");
          setTError1("")
          setTError2("")
        } else {
          setTNotification("");
          setTError("");
          setTError1("Number of days should be less than 30 days");
        }
      }
    } else {
      setTNotification("");

      setTError1("");
      if(SNotification?.length==0){
      setTError2("Please Enter Second notification")}
    }

  };

  const SaveorDeleteNotifications = async () => {
    if (ID == 1 || ID == 2) {
      setDis(true);
      if (FNotification != "" && FError == "" && SError == "" && TError == "") {
        const data = {
          "organizationId": CLIENTID,
          "setupType": DATA?.setupType,
          "setupTypeId": DATA?.setupTypeId == 1 ? -1 : DATA?.setupTypeId,
          "firstNotification": FNotification,
          "secondNotification": SNotification == "" ? null : SNotification,
          "thirdNotification": TNotification == "" ? null : TNotification,
          "isInsert": ID == 1 ? true : DATA?.isInsert,
          "orgEmailSetupId": ID == 1 ? -1 : DATA?.orgEmailSetupId,
        }
        const res = await axios.post("EmailSetupNotifications/AddEmailSetupInvitationNotification", data);
        if (res?.data?.responseCode == 100) {
          toastNotify(res?.data?.responseMessage, true);
          setTimeout(() => {
            CLOSE();
          }, 500);

        } else {
          toastNotify(res?.data?.responseMessage, false);
          setDis(false);
        }

      } else {
        toastNotify("Please enter mandatory fields", false);
        setDis(false);
      }
    } else if (ID == 3) {
      const resp = await axios.post("EmailSetupNotifications/DeleteInvitationNotification?OrgEmailSetupId=" + SETUPID);
      if (resp?.data?.responseCode == 100) {
        toastNotify(resp?.data?.responseMessage, true);
        setTimeout(() => {
          CLOSE();
        }, 500);

      } else {
        toastNotify(resp?.data?.responseMessage, false);
      }

    }
    setTimeout(() => {
      INFO(CLIENTID);
      setDis(false);
    }, 500);


  }


  return (
    <>
      <div>
        <ToastContainer />
        <div className="">
          {ID == 3 ?
            "Are you sure do you want to delete this notification?" :
            <>

              <div className="mt-2">
                <span style={{ color: "#3E4A62", fontSize: "20px" }}>
                  First Notification (Days) <span style={{ color: "red" }}>*</span>
                </span>
                <br />
                <TextField
                  placeholder=""
                  type="number"
                  InputProps={{ inputProps: { min: "1", max: "29" } }}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                  value={FNotification}
                  onChange={(e) => ChangeNotification(e.target.value)}
                />
                <br />
              </div>
              <div style={{ width: "320px" }}>
                <span style={{ color: "red" }}>{FError}</span>
              </div>


              <div className="mt-2">
                <span style={{ color: "#3E4A62", fontSize: "20px" }}>
                  Second Notification (Days){" "}
                </span>
                <br />
                <TextField
                  placeholder=""
                  type="number"
                  InputProps={{ inputProps: { min: "1", max: "29" } }}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                  value={SNotification}
                  onChange={(e) => ChangeNotification2(e.target.value)}
                />
                <br />
              </div>
              <div style={{ width: "320px" }}>
                <span style={{ color: "red" }}>{SError}</span>
                <span style={{color:"red"}}>{SError1}</span>
              </div>


              <div className="mt-2">
                <span style={{ color: "#3E4A62", fontSize: "20px" }}>
                  Third Notification (Days){" "}
                </span>
                <br />

                <TextField
                  placeholder=""
                  type="number"
                  InputProps={{ inputProps: { min: "1", max: "29" } }}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                  value={TNotification}
                  onChange={(e) => ChangeNotification3(e.target.value)}
                />
                <br />
              </div>
              <div style={{ width: "320px" }}>
                <span style={{ color: "red" }}>{TError}</span>
                <span style={{color:"red"}}>{TError1}</span>
                <span style={{color:"red"}}>{TError2}</span>
              </div>

            </>}
        </div>

        <DialogActions>
          <div className="login-help__buttonContainer mt-4">
            <Button variant="contained" className="login-help-button-cancel mx-2" onClick={CLOSE}>Cancel</Button>
            <Button variant="contained" disabled={Dis ||SError1!=""||TError1!=""} className="login-button-request mx-2" onClick={SaveorDeleteNotifications}>{ID == 3 ? "Ok" : ID == 1 ? "Add " : "Save"}</Button>
          </div>
        </DialogActions>
      </div>
    </>
  );
}
